import React from 'react'
import { HashLink } from 'react-router-hash-link'
import styled from 'styled-components'
import Button from '../../Tool-kit/Button'
import Flex from '../../Tool-kit/Flex'
import { Section } from '../../Tool-kit/Section'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import Text from '../../Tool-kit/Typography'
const { REACT_APP_STRAPI_API_URL } = process.env
import * as qs from 'qs'
import { useState, useEffect } from 'react'
import { useLocale } from 'hooks/useLocale'
import useSWR from 'swr'
const Wrapper = styled('div')`
  width: 100%;
  margin-bottom: 18.1rem;
  padding-top: 8.6rem;
  position: relative;
  overflow: hidden;
  .grey-bg {
    position: absolute;
    width: 100%;
    top: 0%;
    background: ${({ theme }) => theme.colors.background4};
    left: 0%;
    height: 22rem;
  }

  @media ${devices.phone} {
    margin-bottom: 10rem;
  }

  .content {
    padding: 3.3rem 10rem;
    width: 65%;
    margin: auto;
    background: ${({ theme }) => theme.colors.background5};
    border-radius: 6px;

    @media ${devices.phone} {
      width: 95%;
      padding: 3.3rem 2rem;
    }
  }
`

const DomainSquare = () => {
  const { locale } = useLocale()
  const [data, setData] = useState()
  const query = qs.stringify({
    populate: {
      button: {
        fields: ['title']
      },
      localizations: {
        populate: '*'
      }
    },
    locale: [locale]
  })
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/bnb-yellowsquares/1?${query}`).then(
      res => res.json()
    )
  const { data: fetchedData } = useSWR(['api/yellowsquare', locale], fetcher)
  console.log(fetchedData)
  const getLocalizedData = () => {
    let localizedData
    fetchedData?.data?.attributes?.localizations?.data?.map(item => {
      if (item?.attributes?.locale === locale) {
        localizedData = item?.attributes
      }
    })
    console.log(localizedData)
    if (localizedData) {
      setData(localizedData)
    } else {
      setData(fetchedData?.data?.attributes)
    }
  }

  useEffect(() => {
    getLocalizedData()
  }, [locale, fetchedData])

  console.log(data)
  return (
    <Wrapper>
      <div className="grey-bg" />
      <Section className="content-wrapper">
        <Flex direction="column" className="content">
          <Text
            font="h4Bold"
            color="white"
            align="center"
            fontFamily="Roboto"
            mb="2rem"
          >
            {data?.content}
          </Text>
          <HashLink smooth to="/contact/#top">
            <Button toggleBackground roundedCorners>
              {data?.button?.title}
            </Button>
          </HashLink>
        </Flex>
      </Section>
    </Wrapper>
  )
}

export default DomainSquare
